import React, {Component, useEffect, useMemo} from 'react';
import OffersPage from './pages/OffersPage';
import Payments from './pages/Payments';
import {
    NavLink,
    Route,
    Outlet,
    Routes,
    useNavigate,
    useLocation,
} from 'react-router-dom';
import Home from './pages/Home';
import EmailAddressNotVerified from './cmp/EmailAddressNotVerified';
import AccountPendingApproval from './cmp/AccountPendingApproval';
import {connect} from 'react-redux';
import ContactUs from './pages/ContactUs';
import {FormattedMessage} from 'react-intl';
import * as localStorage from '../tools/storage';
import CustomPage from './pages/CustomPage';
import LogoRender from "./cmp/LogoRender";
import LazyPageBuilder from "./pages/pagebuilder/LazyPageBuilder";
import LazyStoreIndex from "./pages/inportalstore/LazyStoreIndex";
import LazyMLMPage from "./pages/mlm/LazyMLMPage";
import LazyHelpPage from "./pages/help/LazyHelpPage";
import LazyAnalyticsPage from "./pages/analytics/LazyAnalyticsPage";
import LazySettingsPage from "./pages/LazySettingsPage";
import LazyW9Page from "./pages/taxforms/w9/LazyW9Page";
import StoreSwitcher from "./pages/cmp/StoreSwitcher";
import {loadCommissions} from "../redux/commissions/commissionsActions";
import LandingFooter from "./pages/landing/components/LandingFooter";
import TransactionsIndex from "./pages/transactions/TransactionsIndex";
import {useSelector} from 'react-redux'
import LazyTipaltiIndex from './pages/tipalti/LazyTipaltiIndex'
import PublicShopOptions from './pages/edit-shop/PublicShopOptions';
import LazyShowcaseIndex from './pages/party-links/PartyLinksIndexLazy';
import W8BENForm from './pages/taxforms/w8-ben/W8BENForm';

export default function DashboardContainer(){
    const aff_inportalstore_enabled = useSelector((state)=>state.settings.aff_inportalstore_enabled)
    const navigate = useNavigate()
    return <Routes>
            <Route element={<ConnectedDashboard navigate={navigate} />}>
            <Route path={'payments'} element={<Payments/>}/>
            <Route path={"analytics"} element={<LazyAnalyticsPage/>}/>
            <Route path={'products'} element={<OffersPage/>}/>
            <Route path={"settings/legal/w9/*"} element={<LazyW9Page/>}/>
            <Route path={"settings/legal/w-8ben"} element={<W8BENForm/>}/>
            <Route path={'settings'} element={<LazySettingsPage/>}/>
            <Route path={'network/*'} element={<LazyMLMPage/>}/>
            <Route path={'help'} element={<LazyHelpPage/>}/>
            <Route path={'mypages/*'} element={<LazyPageBuilder/>}/>
            {
                aff_inportalstore_enabled &&
                <Route path={"store"} element={<LazyStoreIndex/>}/>
            }
            <Route path={"edit-shop"} element={<PublicShopOptions/>} />
            <Route path={'pages/:page_id'} element={<CustomPage/>}/>
            <Route path={'partner-contact'} element={<ContactUs/>}/>
            <Route path={"transactions"} element={<TransactionsIndex/>} />
            <Route path={"tipalti/*"} element={<LazyTipaltiIndex/>} />
            <Route path={"party-links"} element={<LazyShowcaseIndex/>} />
            <Route index element={<Home/>}/>
        </Route>
    </Routes>
}

class Dashboard extends Component {
    state = {
        selected: {},
        opts: [],
        collapsed: true,
    }

    componentDidMount() {
        this.props.loadCommissions();
    }

    handleLogout = () => {
        localStorage.removeItem('access_token');
        this.props.navigate('/logout');
    }

    toggleNavbar = () => {
        this.setState({collapsed: !this.state.collapsed})
    }



    getTabs = () => {
        const tabs = [];
        if (this.props.aff_home_enabled) tabs.push({to: '/', id: 'navlinkHome', exact: true});
        if (this.props.aff_products_enabled) tabs.push({to: '/products', id: "Marketing Tools"});
        if (this.props.showcaseConfig) tabs.push({to:'/party-links', id:'Party Links'})
        if (this.props.enable_page_builder) tabs.push({to: '/mypages', id: "Pages"});
        if (this.props.aff_analytics_enabled) tabs.push({to: '/analytics', id: "Analytics"});
        if (this.props.mlm_enabled && this.props.aff_network_tab_show) tabs.push({to: '/network', id: "Network"});
        if(this.props.aff_inportalstore_enabled) tabs.push({to:'/store',id:'Store'});
        if(this.props.aff_show_transactions) tabs.push({to:"/transactions",id:'Transactions'});
        if (this.props.aff_payments_enabled) tabs.push({to: '/payments', id: "navlinkPayments"});
        this.props.aff_extra_tabs.filter((item) => String(item.page_status) === '1' && String(item.title).trim()).forEach((item) => tabs.push({
            to: `/pages/${item.id}`,
            id: item.title
        }))
        if (this.props.aff_settings_enabled) tabs.push({to: '/settings', id: "navlinkSettings"});
        return tabs;
    }


    render() {
        const {nav_as_sidebar} = this.props.affiliate_portal_config || {};
        const bgColorStyle = {
            backgroundColor: this.props.dashboard_bg_color || 'inherit'
        };
        const {active_tab_color, inactive_tab_color, logo_align} = this.props;
        const inactiveStyle = inactive_tab_color ? {color: inactive_tab_color} : {};
        const tabs = this.getTabs();
        return (
            <div className={`${this.props.isEmbedded || this.props.dashboard_bg_color ? '' : 'bg-light '} min-vh-100`}
                 style={bgColorStyle}>
                <div className={`${nav_as_sidebar ? 'container-fluid' : 'container'} px-0 py-3`} style={{position: 'relative'}}>
                    {
                        !this.props.isEmbedded &&
                        <StoreSwitcher/>
                    }
                    <div>
                        {
                            this.props.aff_logo_on_dashboard &&
                            <div className={`mt-2 ${logo_align === "center" ? 'text-center' : ''}`}>
                                <LogoRender height={80}/>
                            </div>
                        }
                    </div>
                </div>
                <div className={`${nav_as_sidebar ? 'container-fluid' : 'container px-0 '} ${this.props.isEmbedded ? '' : ' pt-4 pb-4'}`}>
                    {
                        !this.props.email_verified && this.props.notify_affiliate_email_verification ?
                            <EmailAddressNotVerified/> : null
                    }
                    {
                        this.props.account_status === 'pending' ? <AccountPendingApproval/> : null
                    }
                    {
                        this.props.account_status === 'blocked' ? <AccountBanned/> : null
                    }
                    <DashboardNavigation
                        isShopifyAutoLogin={this.props.isShopifyAutoLogin}
                        tabs={this.getTabs()} />
                    {
                        nav_as_sidebar ? <>
                            <div className={"row"}>
                            <div className="col-md-3 d-none d-md-block">
                                <RenderTabs sidebar={nav_as_sidebar} tabs={tabs} isShopifyAutoLogin={this.props.isShopifyAutoLogin}
                                            inactiveStyle={inactiveStyle} inactive_tab_color={inactive_tab_color} active_tab_color={active_tab_color}
                                            handleLogout={this.handleLogout}
                                />
                            </div>
                            <div className="col-md-9">
                                <DashboardRoutes isEmbedded={this.props.isEmbedded} />
                            </div>
                        </div>
                            {
                                !this.props.isShopifyAutoLogin ? <div className={"text-right"}>
                                    <button className={'px-0 btn'} onClick={this.handleLogout}
                                            style={inactiveStyle}>
                                        <FormattedMessage id={'logout'}/></button>
                                </div> : null
                            }
                        </> :  <> <RenderTabs tabs={tabs} isShopifyAutoLogin={this.props.isShopifyAutoLogin}
                                               inactiveStyle={inactiveStyle} inactive_tab_color={inactive_tab_color} active_tab_color={active_tab_color}
                                               handleLogout={this.handleLogout}
                        />
                            <DashboardRoutes isEmbedded={this.props.isEmbedded} />
                        </>
                    }
                </div>
                <div className="pb-4"/>
                {
                    !this.props.isEmbedded && <LandingFooter inDashboard/>
                }
                <EmbeddedIFrameSendReferralCodeToParent />
            </div>
        );
    }
}

function DashboardNavigation({tabs, isShopifyAutoLogin}){
    const navigate = useNavigate()
    const location = useLocation()
    const doNav = (e) => {
        navigate(e.target.value)
    }
    const navValue = useMemo(() => {
        const foundPath = tabs.find((item) => {
            return location.pathname.startsWith(item.to) && !item.exact;
        });

        return foundPath ? foundPath.to : location.pathname
    },[tabs, location])
    return <>
        <select className={"form-control d-block d-md-none border-bottom"} value={navValue} onChange={doNav}>
            {
                tabs.map((item) => {
                    return <FormattedMessage key={String(item.id)} id={item.id}>{text => <option
                        value={item.to}>{text}</option>}</FormattedMessage>
                })
            }
            <option value={"/"}>---</option>
            {
                !isShopifyAutoLogin ?
                    <FormattedMessage id={"Logout"}>{text => <option
                        value="/logout">{text}</option>}</FormattedMessage> : null
            }
        </select>
    </>
}

function DashboardRoutes({isEmbedded}){
    return  <div
        className={`border-right border-left border-bottom bg-white p-4 rounded-bottom ${!isEmbedded && 'shadow'}`}>
        <Outlet />
    </div>
}

function RenderTabs({handleLogout, sidebar, tabs, active_tab_color, inactive_tab_color, inactiveStyle, isShopifyAutoLogin}){
    const inactive_tab_style = inactive_tab_color ? {color: inactive_tab_color} : {};
    const active_tab_style = active_tab_color ? {color: active_tab_color} : {};
    if(sidebar){
        return <ul className="list-group d-none d-md-flex">
            {
                tabs.map((item) => <NavLink
                    key={item.to}
                    end={item.exact}
                    className={({isActive})=>`list-group-item list-group-item-action ${isActive ? 'bg-primary text-white' : ''}`}
                    style={({isActive})=>isActive ? active_tab_style : inactive_tab_style}
                    to={item.to}>
                    <FormattedMessage id={item.id}/>
                </NavLink>)
            }
        </ul>
    }
    else{
        return <ul className="nav nav-tabs d-none d-md-flex">
            {
                tabs.map((item) => <li  key={item.to} className="nav-item">
                    <NavLink

                             className={({isActive})=>`nav-link ${isActive ? 'active' : ''}`}
                             end={item.exact}
                             to={item.to} style={({isActive})=>isActive ? active_tab_style : inactive_tab_style}
                            >
                        <FormattedMessage id={item.id}/>
                    </NavLink>
                </li>)
            }
            {
                !isShopifyAutoLogin ? <>
                    <li className={'justify-content-end d-none d-md-flex'} style={{flex: 1}}>
                        <button className={'px-0 btn btn-link'} onClick={handleLogout}
                                style={inactiveStyle}>
                            <FormattedMessage id={'logout'}/></button>
                    </li>
                </> : null
            }
        </ul>
    }
}


const tabOrder = ['home','marketing-tools','party-links','shop','transactions','payments','settings']

const useTags = ()=>{

    const tabs = [];
    if (this.props.aff_home_enabled) tabs.push({to: '/', id: 'navlinkHome', exact: true});
    if (this.props.aff_products_enabled) tabs.push({to: '/products', id: "Marketing Tools"});
    if (this.props.showcaseConfig) tabs.push({to:'/party-links', id:'Party Links'})
    if (this.props.enable_page_builder) tabs.push({to: '/mypages', id: "Pages"});
    if (this.props.aff_analytics_enabled) tabs.push({to: '/analytics', id: "Analytics"});
    if (this.props.mlm_enabled && this.props.aff_network_tab_show) tabs.push({to: '/network', id: "Network"});
    if(this.props.aff_inportalstore_enabled) tabs.push({to:'/store',id:'Store'});
    if(this.props.aff_show_transactions) tabs.push({to:"/transactions",id:'Transactions'});
    if (this.props.aff_payments_enabled) tabs.push({to: '/payments', id: "navlinkPayments"});
    this.props.aff_extra_tabs.filter((item) => String(item.page_status) === '1' && String(item.title).trim()).forEach((item) => tabs.push({
        to: `/pages/${item.id}`,
        id: item.title
    }))
    if (this.props.aff_settings_enabled) tabs.push({to: '/settings', id: "navlinkSettings"});
    return tabs;
}


function AccountBanned() {
    return (<p className={'alert alert-danger'}>
        <FormattedMessage id={'accountBannedMessage'}/>
    </p>);
}

function EmbeddedIFrameSendReferralCodeToParent(){
    const isEmbedded = useSelector((state)=>state.settings.isEmbedded)
    const ref_code = useSelector((state)=>state.settings.ref_code)
    useEffect(()=>{
        if(window.top && ref_code){
            window.top.postMessage('set-ref-code:'+ref_code, '*')
        }
    },[isEmbedded, ref_code])
    return null
}

const mapStateToProps = (state, props) => {
    const {
        notify_affiliate_email_verification,
        page_sections, aff_logo_on_dashboard, store_logo, store_name,
        email_verified, status,
        aff_analytics_enabled,
        aff_inportalstore_enabled,
        aff_show_transactions,
        affiliate_portal_config,
    } = state.settings;
    const {logo_align} = (page_sections.default_navigation && page_sections.default_navigation.props) || {};
    let aff_extra_tabs = [];
    if(state.settings.aff_extra_tabs){
        aff_extra_tabs = typeof  state.settings.aff_extra_tabs === "string" ? JSON.parse(state.settings.aff_extra_tabs) : state.settings.aff_extra_tabs
    }
    return {
        notify_affiliate_email_verification,
        store_logo,
        store_name,
        email_verified,
        account_status: status,
        website: state.settings.website,
        mlm_enabled: state.settings.mlm_enabled,
        aff_home_enabled: state.settings.aff_home_enabled === undefined ? true : state.settings.aff_home_enabled,
        aff_payments_enabled: state.settings.aff_payments_enabled === undefined ? true : state.settings.aff_payments_enabled,
        aff_settings_enabled: state.settings.aff_settings_enabled === undefined ? true : state.settings.aff_settings_enabled,
        aff_products_enabled: state.settings.aff_products_enabled === undefined ? true : state.settings.aff_products_enabled,
        aff_analytics_enabled,
        subscription: state.settings.subscription,
        isEmbedded: state.settings.isEmbedded,
        dashboard_bg_color: state.settings.dashboard_bg_color,
        active_tab_color: state.settings.active_tab_color,
        inactive_tab_color: state.settings.inactive_tab_color,
        aff_extra_tabs,
        aff_logo_on_dashboard,
        enable_page_builder: state.settings.enable_page_builder,
        aff_show_transactions,
        aff_network_tab_show: state.settings.aff_network_tab_show === undefined ? true : state.settings.aff_network_tab_show,
        logo_align,
        aff_inportalstore_enabled,
        affiliate_portal_config: affiliate_portal_config ? JSON.parse(affiliate_portal_config) : {},
        showcaseConfig: state.settings.showcaseConfig,
    }
}

function mapDispatchToProps(dispatch){
    return {
        loadCommissions: ()=>dispatch(loadCommissions()),
    }
}

const ConnectedDashboard = connect(mapStateToProps, mapDispatchToProps)(Dashboard);
